import Stack from '@mui/material/Stack'
import { observer } from 'mobx-react-lite'
import onEnterProp from 'reusable/utils/on-enter-prop'
import ButtonWithProgress from 'reusable/mui/progress-button/ButtonWithProgress'
import onBlurProp from 'reusable/utils/on-blur-prop'
import TextFieldPassword from 'reusable/mui/text-field-password/TextFieldPassword'
import useStore from 'reusable/mobx-store-utils'
import AuthCardWrapper from 'auth/shared/AuthCardWrapper'
import { useAuthStore } from 'auth/AuthStore'
import AuthSignInNewPasswordRequiredStore from './AuthSignInNewPasswordRequiredStore'

export default observer(function AuthSignInNewPasswordRequired() {
   const authStore = useAuthStore()
   const authChangePasswordStore = useStore(() => new AuthSignInNewPasswordRequiredStore(authStore))
   const formHandler = authChangePasswordStore.formHandler

   return (
      <AuthCardWrapper title={'Create New Password'}>
         <Stack spacing={3}>
            {formHandler.newPassword.bindInput(ip =>
               <TextFieldPassword
                  autoFocus
                  fullWidth
                  label="New Password"
                  {...onBlurProp(authChangePasswordStore.validatePasswordsMatch)}
                  {...onEnterProp(authChangePasswordStore.updatePassword)}
                  {...ip}
               />
            )}
            {formHandler.confirmPassword.bindInput(ip =>
               <TextFieldPassword
                  fullWidth
                  label="Confirm Password"
                  skipValidation
                  {...onBlurProp(authChangePasswordStore.validatePasswordsMatch)}
                  {...onEnterProp(authChangePasswordStore.updatePassword)}
                  {...ip}
               />
            )}
            <ButtonWithProgress
               loading={authChangePasswordStore.loader.isLoading}
               variant="contained"
               onClick={authChangePasswordStore.updatePassword}>
               Change Password
            </ButtonWithProgress>
         </Stack>
      </AuthCardWrapper>
   )
})
